import Button from 'components/CustomButtons/Button';
import CanPerform from 'components/CanPerform/CanPerform';
import React from 'react';
import { IButton } from 'components/TableHeader/TableHeader';
import styles from 'assets/jss/material-dashboard-pro-react/components/tableHeaderStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISingleHeaderButtonProps {
	button: IButton;
}

const SingleHeaderButton = ({ button }: ISingleHeaderButtonProps) => {
	const classes = useStyles();
	return (
		<CanPerform
			action={button.action}
			yes={
				<div className={classes.wrapper}>
					<Button color="tertiary-light" id={button.id} onClick={button.onClick} {...button.buttonProps}>
						{button.text}
					</Button>
				</div>
			}
		/>
	);
};

export default SingleHeaderButton;
